export enum Namespace {
    APP = 'FUTURIZE_LMS',
}

export enum Endpoint {
    LMS_API = '/public/v2/tmf-api/sales/v4/salesLead',
    CAPTCHA_API = '/public/v2/captcha',
}

export enum ApiKey {
    API_VF = '2mPLbrEtIUPWTtUIllrUDtnyk4g0IxgC', // prod
    PRE_PROD_API = 'CwcWV5Jvb7N3aQe4zCO1SA6usS0Ii9mP', // pre-prod!
}

export enum SelectorStyleClass {
    CLASSNAME_FOOTNOTE_LINK = 'ws10-footnote-link',
    FOOTNOTE_SELECTOR = 'div.mod.mod-footnotes > div > div > ol > li',
    CLASSNAME_FOOTNOTE_ACCORDION = 'mod mod-footnotes',
}
